import { IPopUpDetails } from "@/apis/services/ConfigServices";
import { generateGUID } from "@/components/common/Utils";
import { navigate } from "gatsby";

export const stockUpdate: any = {
  availableStock: 'We only have few items left for some products as listed below. Kindly adjust your cart quantity(s) accordingly.',
  validationHeader: 'Your order is not placed due to some reason mentioned below.'
}

export const deliveryMethodMessage = {
  noShippingAtAddress: 'This product is currently not being shipped to Canada.',
  noSecureShipping: 'This product is not available for Secured Shipping.'
}

export const stockStatus: any = {
  profit: 'profit',
  loss: 'loss',
}

export function formatDate(dateString: any) {
  const options: any = { year: 'numeric', month: 'long', day: 'numeric' };
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', options);
}
// function formatDate(timestamp) {
//   const date = new Date(timestamp);
//   const day = date.getDate().toString().padStart(2, '0');
//   const month = (date.getMonth() + 1).toString().padStart(2, '0');
//   const year = date.getFullYear();

//   return `${day}/${month}/${year}`;
// }
export function progressBarLogic({ currentprice, min, max }: any) {
  return ((currentprice - min) / (max - min)) * 100
}

export function valueChangeForPrice({ currentprice, yesterdayprice }: { currentprice: number, yesterdayprice: number }) {
  return (((currentprice - yesterdayprice) / yesterdayprice) * 100).toFixed(2)
}
export function roundOfThePrice(price: any) {
  if (price == null || isNaN(Number(price))) {
    return '...';
  }
  const roundedPrice = Number(price).toFixed(2);
  return roundedPrice;
}

export const shipmentTypeToEnum: any = {
  'LocalShipping': 3,
  'SecureShipping': 2,
  'VaultStorage': 1
}
export const shipmentNameEnum: any = {
  'LocalShipping': 'Local Pick Up',
  'SecureShipping': 'Secure Shipping',
  'VaultStorage': 'Vault storage'
}
export const isBrowser = typeof window !== "undefined"
export function localStorageGetItem(key: any) {
  return isBrowser && key ? (localStorage?.getItem(key) === 'undefined' ? undefined : localStorage?.getItem(key)) : undefined
}

export function localStorageSetItem(key: any, value: any) {
  if (isBrowser) {
    value = (typeof value !== 'string') ? JSON.stringify(value) : value
    localStorage?.setItem(key, value)
    // Store in cookies manually
    if (key == "isLoggedIn") {
      const isLoggedInValue = typeof value === 'string' && value.startsWith('"') ? JSON.parse(value) : value;
      document.cookie = `isLoggedIn=${isLoggedInValue}; path=/; max-age=${7 * 24 * 60 * 60}`; // 7 days expiry
    }
    if (key == "userDetails") {
      const userDetails = typeof value === 'string' && value.startsWith('"') ? JSON.parse(value) : value;
      const uniqueSessionId = userDetails?.customerGuid ?? generateGUID()
      document.cookie = `uniqueSessionId=${uniqueSessionId}; path=/; max-age=${7 * 24 * 60 * 60}`;
    }
  }
}
export function sessionStorageGetItem(key: any) {
  if (isBrowser && sessionStorage) {
    const value: any = sessionStorage.getItem(key);
    return value
  }
  return undefined;
}
export function sessionStorageSetItem(key: any, value: any) {
  if (isBrowser && sessionStorage) {
    sessionStorage.setItem(key, typeof value !== 'string' ? JSON.stringify(value) : value);
  }
}
export function hasFulfilled(dataType: string): boolean {
  return dataType.includes('/fulfilled');
}
// Function to store the last 5 unique pages in session storage
export const storeLastPage = (pageUrl: string) => {
  // List of URLs to exclude (base paths only, without query params)
  const excludedUrls = [
    '/password-recovery',
    '/forgot-password',
    '/login',
    '/email-confirmation',
    '/confirmation',
    '/activate-account',
    '/order-confirmation',
    '/checkout',
    '/registration',
  ];

  // Extract the pathname from the URL (ignores query params and hash fragments)
  const urlPath = new URL(pageUrl, window.location.origin).pathname;

  // Check if the URL path is excluded
  if (excludedUrls.includes(urlPath)) {
    return; // Exit if the URL path matches any excluded URL
  }

  // Retrieve the existing stack from session storage
  const storedStack = JSON.parse(sessionStorage.getItem('lastPages') || '[]');

  // Check if the new page URL is the same as the first entry to avoid duplicates
  if (storedStack[0] === pageUrl) {
    return;
  }

  // Insert the new page URL at the beginning of the stack
  storedStack.unshift(pageUrl);

  // Limit the stack to the last 5 pages
  if (storedStack.length > 5) {
    storedStack.pop();
  }

  // Store the updated stack back in session storage
  sessionStorage.setItem('lastPages', JSON.stringify(storedStack));
};


// Function to retrieve the last 5 unique pages stack
export const getLastPage = (): string => {
  return JSON.parse(sessionStorage.getItem('lastPages') || '[]')[0];
};
export const getLastPageStack = (): string[] => {
  return JSON.parse(sessionStorage.getItem('lastPages') || '[]');
};

// Function to store the last page in session storage
// export const storeLastPage = (pageUrl: string) => {
//   if (!pageUrl.includes("login") && !pageUrl.includes('register')) {
//     sessionStorage.setItem('lastPage', pageUrl);
//   }
// };

// // Function to retrieve the last page from session storage
// export const getLastPage = () => {
//   return sessionStorage.getItem('lastPage');
// };

export const PriceFacturationEnum: { [key: string]: "error" | "success" } = {
  "0": "success",
  "1": "success",
  "2": "error"
}
export const bodyForGetShoppingCartData = {
  "search": "",
  "pageNo": 0,
  "pageSize": -1,
  "sortBy": "",
  "sortOrder": "",
  "filters": {}
}

export function getDefaultOption(enabledOptions: any[], defaultOption: string | number) {
  const enabledValues = enabledOptions.filter(option => option.enabled).map(option => option.value);
  return enabledValues.length > 0 ? enabledValues[0] : defaultOption;
}
export const paymentMethodType: any = {
  "CreditCard": 'Credit Card',
  "BankTransfer": 'Bank Transfer',
  "Cash": 'Cash',
}
// Debounce function
export const debounceFunction = (func: any, delay: any) => {
  let timeoutId: any;
  return function (...args: any) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this as any, args);
    }, delay);
  };
};
// Function to capitalize the first character
export const capitalizeFirstChar = (str: any) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// color for metals
export const metalColors: any = {
  "gold": "#FFCC00",
  "silver": "#CCCCCC",
  "platinum": "#99CCFF",
  "palladium": "#CC99CC"
}
// function to convert minutes to milliseconds
export const convertMinutesToMilliseconds = (minutes: number | string): number => {
  // Convert minutes to milliseconds
  const milliseconds = Number(minutes) * 60 * 1000;
  return milliseconds;
};

export const AccountTypeEnumReverse: { [key: string]: string } = {
  "1": "Individual",
  "2": "Joint",
  "3": "Business",
  "4": "Superfund",
  "5": "Trust",
  "6": "Wholesaler"
}
export const AccountTypeEnum: { [key: string]: string } = {
  "Individual": "1",
  "Joint": "2",
  "Business": "3",
  "Superfund": "4",
  "Trust": "5",
  "Wholesaler": "6"
}

export const checkThePopUpDetails = async (paramsObj: IPopUpDetails, openPopup: any, dispatch: any, service: any) => {
  // const res = await ConfigServices.getPopUpDetails(paramsObj)
  const res = await dispatch(service(paramsObj))
  if (res?.payload?.data?.data?.htmlCode) {
    openPopup(true)
    return true
  }

  return false
}
// export const calculationOfThePremiumAndDiscount = (premium: string | number, premiumDiscount: string | number) => {
//   const numbre = Math.round((Number(premiumDiscount) / Number(premium)) * 100)
//   return "SAVE " + numbre + "%"
// }
export const calculationOfThePremiumAndDiscount = (premium: string | number, premiumDiscount: string | number): string | null => {
  const parsedPremium = Number(premium);
  const parsedDiscount = Number(premiumDiscount);

  // Check if parsedPremium and parsedDiscount are valid numbers
  if (isNaN(parsedPremium) || isNaN(parsedDiscount) || parsedPremium === 0) {
    return null;
  }

  let percentage = roundOfThePrice((parsedDiscount / parsedPremium) * 100);

  if (isNaN(Number(percentage))) {
    return null;
  }

  percentage = percentage.slice(percentage.length - 2, percentage.length) === '00'
    ? percentage.slice(0, percentage.length - 3)
    : percentage

  return `${percentage}% off the premium`;
}
export const getlastPartOfPath = (path: any) => {
  const parts = path.split('/').filter((part: string) => part !== '');

  // Get the last part of the path
  const lastPartOfPath = parts[parts.length - 1];
  return lastPartOfPath
}
export const getLengthOfThePaths = (path: any) => {
  const parts = path.split('/').filter((part: string) => part !== '');

  return parts
}
export const openNewTab = (url: any) => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // Open a new tab for external URLs
    window.open(url, '_blank');
  } else {
    // For internal URLs, use Gatsby's navigate function
    navigate(url);
  }
};
export const formatCategoryUrl = (pageName: any) => {
  // Check if pageName starts with '/' and adjust URL accordingly
  const formattedPageName = pageName.startsWith('/') ? pageName : `/${pageName}`;
  return formattedPageName;
};

export const PRODUCT_PATH_PREFIX = '/shop/product/';

// Normalizes the API's `friendlypagename` into the canonical /shop/product/
// path regardless of whether the backend sends a bare slug, a slug with a
// leading slash, or one already carrying the prefix — every internal product
// link (cards, search, cart, wishlist, compare) and the product page's own
// canonical tag route through this so they can never diverge onto the old
// bare-slug URL structure.
export const buildProductUrl = (friendlypagename?: string | null): string => {
  if (!friendlypagename) return '';
  const slug = friendlypagename.replace(/^\/+/, '').replace(/^shop\/product\//, '');
  return `${PRODUCT_PATH_PREFIX}${slug}`;
};
export const pagesOnWhichNeedToCallTopCategoriesAPi = ['login', 'registration', 'password-recovery', 'blog', 'news', 'forgot-password', "topic", "confirmation", "activate-account", "contactus", "email-confirmation", "404", "newpage"]
export const isItNewsOrBlogPage = ['login', 'registration', 'password-recovery', 'blog', 'news', 'forgot-password', "topic", "confirmation", "activate-account", "contactus", "email-confirmation", "404"]
export const joinWithPipe = (parts: any[]) => {
  return parts.filter(part => part != null && part !== '').join(' | ');
};
export function calculatePrice(product: any, qty: any) {
  // Destructure the product object to get the necessary properties
  if (product) {
    const { price, tierPriceList } = product;

    // If there is no tierPriceList or it's empty, return the base price
    if (!tierPriceList || tierPriceList.length === 0) {
      return price;
    }

    // Find the tier price that matches the given quantity
    const tier = tierPriceList.find((tier: any) => qty >= tier.fromQty && qty <= tier.toQty);

    // If a matching tier price is found, return the tier price, otherwise return the base price
    return tier ? tier.price : price;
  }
}
export enum ShippingMethod {
  LocalShipping = 'localShipping',
  VaultStorage = 'vaultStorage',
  SecureShipping = 'secureShipping',
}
export const ShippingMethodToNumber = {
  VaultStorage: 1,
  secureShipping: 2,
  localShipping: 3,
}
export function getCommonShippingMethods(products: any): number[] {
  if (products.length === 0) {
    return [];
  }

  // Initialize commonMethods with the allowed shipping methods of the first product
  let commonMethods = products[0].allowedShippingMethods;

  // Iterate through the rest of the products to find common shipping methods
  for (const product of products) {
    commonMethods = commonMethods.filter((method: any) =>
      product.allowedShippingMethods.includes(method)
    );

    // If no common methods are left, return an empty array early
    if (commonMethods.length === 0) {
      return [];
    }
  }

  return commonMethods;
}
export const DEFAULT_VALUE_FOR_SHIPPING_METHOD = 5
type PromiseResult<T> =
  | { status: 'fulfilled'; value: T }
  | { status: 'rejected'; reason: any };


export const wrapPromise = <T>(promise: Promise<T>): Promise<PromiseResult<T>> => {
  return promise
    .then(value => ({ status: 'fulfilled' as const, value }))
    .catch(reason => ({ status: 'rejected' as const, reason }));
};
export const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (/mobile/i.test(userAgent)) {
    return "Mobile";
  }

  if (/tablet/i.test(userAgent) || /ipad|playbook/i.test(userAgent) || (navigator.userAgent.toLowerCase().includes("android") && !userAgent.includes("mobile"))) {
    return "Tablet";
  }

  return "Desktop";
};

// Builds a LocalBusiness JSON-LD schema from store config so search engines and
// generative systems have a reliable, hydration-independent entity/local signal
// on the homepage (there was previously no structured data on the site at all).
export const getOrganizationSchema = (configDetails: any) => {
  const storeName = configDetails?.Store_Title?.value;

  // Only the name is truly required; every other field (including the site
  // URL, which is a build-time env var and can be unset in some local/dev
  // setups) degrades gracefully instead of dropping the whole schema.
  if (!storeName) return null;

  const storeUrl = process.env.GATSBY_STORE_URL;
  const logo = configDetails?.BrandLogoURL_Header?.value || configDetails?.BrandLogoURL_Footer?.value;
  const address = configDetails?.Store_Address?.value;
  const phone = configDetails?.StorePhoneNumber_AU?.value;
  const sameAs = [
    configDetails?.SocialLinks_Facebook?.value,
    configDetails?.SocialLinks_Instagram?.value,
    configDetails?.SocialLinks_Twitter?.value,
    configDetails?.SocialLinks_Youtube?.value,
  ].filter(Boolean);

  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: storeName,
    ...(storeUrl && { url: storeUrl }),
    ...(logo && { logo, image: logo }),
    ...(phone && { telephone: phone }),
    ...(address && { address: { "@type": "PostalAddress", streetAddress: address } }),
    ...(sameAs.length > 0 && { sameAs }),
  };
};

// Same ImageKit resize/format proxy already used by the product card
// components (Card.tsx, BmkProductCard.tsx), parameterized so callers that
// need a different size (e.g. the product detail page's full-size/zoomable
// image) don't have to ship the original, full-resolution file.
const PRODUCT_IMAGE_TRANSFORM_PREFIX: Record<string, string> = {
  "1": "https://ik.imagekit.io/coym4wdtlq/tr:w-{w},h-{h},q-70,f-webp/",
  "0": "https://ik.imagekit.io/e8vhhkvuxh2c/tr:w-{w},h-{h},q-auto,f-auto/",
};

export const getOptimizedProductImageUrl = (url: string, width: number, height: number = width) => {
  if (!url) return url;
  const cleanUrl = url.split("?")[0];
  const template = PRODUCT_IMAGE_TRANSFORM_PREFIX[process.env.GATSBY_THEME_TYPE ?? "0"];
  if (!template) return cleanUrl;
  const prefix = template.replace("{w}", String(width)).replace("{h}", String(height));
  return cleanUrl.replace("https://qmintmedia.azureedge.net/pictures/products/", prefix);
};
